module.exports = __webpack_public_path__ + "static/media/warning-sign.c94a4bed.svg";